import { __awaiter, __generator } from "tslib";
import { mergeObjects } from '../utilities/merge-objects';
import { commonFetch } from './common-fetch';
export var fetchGet = function (url, options, requestMode) {
    if (options === void 0) { options = {}; }
    if (requestMode === void 0) { requestMode = 'cors'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var defaultOptions, fetchOptions;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    defaultOptions = { method: 'GET', mode: requestMode };
                    fetchOptions = mergeObjects(options, defaultOptions);
                    return [4 /*yield*/, commonFetch(url, fetchOptions)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
};
